import { DragDropContext, DropResult } from '@hello-pangea/dnd';
import { FC, PropsWithChildren, useCallback } from 'react';

import { SortableContent } from './SortableContent';
import { SortableItem } from './SortableItem';
import { SortableItemHandle } from './SortableItemHandle';

interface Props {
	onReorder: (fromIndex: number, toIndex: number) => void;
	canReorder?: (fromIndex: number, toIndex: number) => boolean;
}

interface Composition {
	Content: typeof SortableContent;
	Item: typeof SortableItem;
	Handle: typeof SortableItemHandle;
}

const Sortable: FC<PropsWithChildren<Props>> & Composition = ({ children, onReorder, canReorder }) => {
	const handleDragEnd = useCallback(
		(result: DropResult) => {
			const { source, destination } = result;
			if (!destination || source.index === destination.index) return;
			if (canReorder && !canReorder(source.index, destination.index)) return;
			onReorder(source.index, destination.index);
		},
		[onReorder, canReorder]
	);

	return <DragDropContext onDragEnd={handleDragEnd}>{children}</DragDropContext>;
};

Sortable.Content = SortableContent;
Sortable.Item = SortableItem;
Sortable.Handle = SortableItemHandle;

export { Sortable };
